const namespaced = true;

const state = {
  message: '',
  typeNotification: 'success',
  show: false,
  editing: false,
  choiceEditing: false
};

const getters = {
  message: state => state.message,
  typeNotification: state => state.typeNotification,
  showNotification: state => state.show,
  editing: state => state.editing,
  choiceEditing: state => state.choiceEditing
};

const mutations = {
  SET_MESSAGE: (state, payload) => {
    state.message = payload;
  },
  SET_NOTIFICATION: (state, payload) => {
    state.show = payload;
  },
  SET_TYPE_NOTIFICATION: (state, payload) => {
    state.typeNotification = payload;
  },
  SET_EDITING: (state, payload) => {
    state.editing = payload;
  },
  SET_CHOICE_EDITING: (state, payload) => {
    state.choiceEditing = payload;
  },
  CLEAR_EDITING: state => {
    state.editing = false;
    state.choiceEditing = null;
  }
};

const actions = {
  showSuccessNotification({ commit }, payload) {
    let message = payload.message ? payload.message : 'Success';
    let timestamp = new Date().getUTCMilliseconds();

    commit('SET_MESSAGE', message);
    commit('SET_TYPE_NOTIFICATION', 'success');
    commit('SET_NOTIFICATION', timestamp);
  },

  showErrorNotification({ commit }, payload) {
    let message = payload.message ? payload.message : 'Error';
    let timestamp = new Date().getUTCMilliseconds();

    commit('SET_MESSAGE', message);
    commit('SET_TYPE_NOTIFICATION', 'error');
    commit('SET_NOTIFICATION', timestamp);
  },

  showErrorReqNotification({ commit }, payload) {
    let message = 'Error';
    let timestamp = new Date().getUTCMilliseconds();

    if (payload.response && payload.response.data) {
      message = payload.response.data.errorMessages || payload.response.data.error || payload.message;
    }

    if (payload?.response?.data) {
      const resData = payload.response.data;
  
      message = resData.errorMessages || resData.error || payload.message || message;
      
      if (Array.isArray(resData.data) && resData.data.length > 0) {
        const messages = resData.data
          .map(item => {
            if (item && typeof item.message === 'string') {
              return item.message;
            }
            return null;
          })
          .filter(Boolean); 
  
        
        if (messages.length > 0) {
          message = messages.join('\n'); 
        }
      }
    }
  

    commit('SET_MESSAGE', message);
    commit('SET_TYPE_NOTIFICATION', 'error');
    commit('SET_NOTIFICATION', timestamp);
  },

  refreshNotification({ commit }) {
    commit('SET_MESSAGE', '');
    commit('SET_TYPE_NOTIFICATION', 'succdss');
    commit('SET_NOTIFICATION', false);
  }
};

export default { namespaced, state, getters, mutations, actions };
